import React, {useState,useEffect} from 'react'
import {defaultSettings, ISettings} from '../modules/profile/components/settings/SettingsModel'
import {defaultAccount, IAccount} from './MyAccountModel'
import Popup from './Popup';
import './style.css';
import region from './address/region.json'
import city from './address/city.json'
import companyLogo from './Avision_Logo.png';
import {db, storage} from './firebase';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import { collection, addDoc } from "firebase/firestore";
import axios from 'axios';
import liff from '@line/liff';

import membercard from './membercard.png';
import {ReactSession } from 'react-client-session';
import {Routes, Route, useNavigate} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";


export function Card() {
  // const storage = getStorage('gs://avliffmemberdev.appspot.com');
  const [logoImage, setLogoImage] = useState('');
  const storageRef = ref_storage(storage, 'image/Avision_Logo.jpg');
  getDownloadURL(storageRef).then((url) => {
    // console.log(url);
    setLogoImage(url)
  });
  // console.log('5555',storageRef);
  // const storage = getStorage('gs://avliffmemberdev.appspot.com');
  const [data1, setdata1] = useState('');
  const storageRef1 = ref_storage(storage, 'config_file/club_scheme_web.json');
  getDownloadURL(storageRef1).then((url1) => {
    //  console.log(ur
     axios.get(url1)
    .then(res=> console.log(res.data))
              
    .catch(err=> console.log(err))
  });

  // console.log('5555',storageRef);


  const [ note, setNote ] = useState("")
  const [data, setData] = useState<IAccount>(defaultAccount)
  //const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();








const togglePopup = () => {
  setIsOpen(!isOpen);
}


/*  const handleClick = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    //notesRef.push(updatedData)


    alert("save data firebase");
  }*/
  const handleClick = async () => {
console.log(data)
  }


  const [selectedOption, setSelectedOption] = useState<String>();
  const [selectedOptionCity, setSelectedOptionCity] = useState<String>();
  const [selectedOptionPoscode, setSelectedOptionPoscode] = useState<String>();


  const updateData = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}

    setData(updatedData)
  }
  const updateDataRegion = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
    setSelectedOption(fieldsToUpdate.country);
  }
  const updateDataCity = (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setSelectedOptionCity(fieldsToUpdate.city);
    setData(updatedData)


  const postcoder = city.map(city=>{

        if(city.City==fieldsToUpdate.city){
      return(setSelectedOptionPoscode(city.PostCode))
    }
  })


  }

const [blogs,setBlogs]=useState([])
const logout = () => {
  liff.logout();
  window.location.reload();
}
 const [name, setName] = useState("");
 const [userLineID, setUserLineID] = useState("");
   const [pictureUrl, setPictureUrl] = useState("");
   const [userclub, setUserclub] = useState("");

async function fetchLiff() {
            let club = (new URLSearchParams(window.location.search)).get("Club_Code");


          /*
          const res = await axios.post('https://portal-otp.smsmkt.com/api/otp-send',{"Club_Code":club}, {
              headers: {
          "Content-Type":"application/json",
          "api_key":"5c96c998aaa1fb1f7132edd3305aa387",
          "secret_key":"gGAj2YrBLdnExGkj",
          },
            }).then(res=> console.log(res))
              .catch(err=> console.log(err))*/
      await liff.init({ liffId: `1657569378-VK8G8bA2` }) //console.log(res)=idlift
    if (liff.isLoggedIn()) {
      let getProfile =  await liff.getProfile();
       setName(getProfile.displayName);
       setUserLineID(getProfile.userId);
       console.log(getProfile);
    }else{
      liff.login();
    }
}
async function fetchchecklogin() {
  const username = window.sessionStorage.getItem("Club_Code1")
  if (username) {
    console.log("suc");

  }else{
    console.log("non");

  }


}

useEffect(() => {
//  fetchLiff();
//  fetchchecklogin();
checkcustomerlogin();
}, [])




        let customerdataweb = window.sessionStorage.getItem('Customerdata');
        // console.log(customerdataweb);
        let customerdatawebconvert= ""+customerdataweb;
        const customerdata = JSON.parse(customerdatawebconvert);


/// style web
let stylesweb = window.sessionStorage.getItem('stylesweb');
let styleswebconvert= ""+stylesweb;
const obj = JSON.parse(styleswebconvert);
// console.log(obj);
const backgroundColor=obj.backgroundColor;
const fontColor=obj.color;
const styles = {
  main: {
    backgroundColor: backgroundColor,
    width: "100%",
  },
  buttonhome: {
    backgroundColor: backgroundColor,
    color: fontColor,
  },
  buttonhome1: {
    backgroundColor: backgroundColor,
    color: fontColor,
  },
  TitleStyle: {
    backgroundColor:"",
    color: "red",
  },
  CaptionStyle: {
    backgroundColor:"",
    color: "red",
  },
  InputDataStyle: {
    backgroundColor:"",
    color: "red",
  },
  ConfirmButtonStyle: {
    backgroundColor:"",
    color: "red",
  },
  CancelButtonStyle: {
    backgroundColor:"",
    color: "red",
  },
  GeneralButtonStyle: {
    backgroundColor:"",
    color: "red",
  },
  ConfirmMessageBoxStyle: {
    backgroundColor:"",
    color: "red",
  },
  SuccessMessageBoxStyle: {
    backgroundColor:"",
    color: "red",
  },
  ErrorMessageBoxStyle: {
  backgroundColor:"",
    color: "red",
  },
  ConsentPageStyle: {
    backgroundColor:"",
    color: "red",
  },
};










// console.log(styles);

    function checkcustomerlogin() {
      const clubid = window.sessionStorage.getItem("Club_Code");

      let clubidweb= ""+clubid;

      if (clubidweb) {
          console.log(userLineID);
        if (userLineID) {
          console.log("sucdd");

        }
      }
    }




  	return (


    <div className='card card-homepage'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo'>        
        <img src={companyLogo} alt="metronic"/>
      </div>

{/* < a href={data1} target="__blank"> Download </a> */}
          <div className='card-body-homepage ' >
            <div className='block-homepage showinfo' style={styles.main}>
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label middle-lable'>{customerdata.first_name + ' ' + customerdata.last_name}</label>
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label middle-lable'>{customerdata.userId}</label>
              <div className='block-buttom-homepage'>
                <div className='block-buttom-lable middle text-left'>
                  <label className='card-label'>{customerdata.mobile_phone_no}</label>
                </div>
                <div className='block-buttom-lable middle text-right'>
                  <label className='card-label'>{customerdata.ramianing_point} Point</label>
                </div>
              </div>
            </div>
          </div>

        {/* end::Form */}

          {/* begin::Form */}



                    <div className='card-body-homepage-middle '>

                      <div className='block-homepage showbody'>
                        <div className='block-homepage-body'>
                          <div className='block-image-body'>
                          <img src={logoImage} alt="metronic"/>
                          </div>
                          <div className='block-homepage-body-button d-flex justify-content-center'>
                              <Button type='submit'  className='btncard btnhomepage w-auto btn btn-info'>
                                Card
                              </Button>
                              <Button type='submit'  className='btnbarcode btnhomepage w-auto btn btn-info'>
                                Barcode
                              </Button>
                              <Button type='submit'  className='btnqr btnhomepage w-auto  btn btn-info'>
                                QRCode
                              </Button>

                          </div>

                        </div>
                      </div>
                    </div>
          {/* end::Form */}
          

      </div>

      
  	)
}
